  export const handleEditChange = (event, setEditHoleNo) => {
    setEditHoleNo(event.target.value);
  };